import React, { useState } from "react";
import { generate } from "generate-password-browser";

function PasswordGenerator({ onPasswordChange }) {
  const [genPassword, setGenPassword] = useState("");

  const handleGenPassword = () => {
    let password = generate({
      length: 10,
      numbers: true,
    });

    setGenPassword(password);
    onPasswordChange(password);
  };
  return (
    <div className="flex lg:w-[48%] justify-between gap-2">
      <input
        className="border-2 border-gray-300 p-2 rounded-md w-[60%] "
        type="text"
        name="password"
        value={genPassword}
        readOnly
      />{" "}
      <button
        type="button"
        onClick={() => handleGenPassword()}
        className="bg-darkblue text-white p-2 rounded-md"
      >
        Generate Password
      </button>
    </div>
  );
}

export default PasswordGenerator;
